import AddSharpIcon from "@mui/icons-material/AddSharp";
import RemoveSharpIcon from "@mui/icons-material/RemoveSharp";
import { Slider, Stack, styled } from "@mui/material";
import type { Dispatch, FC } from "react";

export interface ZoomSliderProps {
  value: number;
  onChange: Dispatch<number>;
  min: number;
  max: number;
}

const GreySlider = styled(Slider)(({ theme }) => ({
  height: 2,
  "& .MuiSlider-rail": {
    opacity: 1,
    backgroundColor: theme.palette.grey["400"],
  },
  "& .MuiSlider-track": {
    opacity: 0,
  },
  "& .MuiSlider-thumb": {
    height: 12,
    width: 12,
    backgroundColor: theme.palette.grey["600"],
  },
}));

export const ZoomSlider: FC<ZoomSliderProps> = ({
  value,
  onChange,
  min,
  max,
}) => {
  const [valueReverse, onChangeReverse] = useReverseScale(
    value,
    onChange,
    min,
    max,
  );

  return (
    <Stack
      width={110}
      spacing={0.5}
      alignContent="center"
      direction="row"
      alignItems="center"
    >
      <RemoveSharpIcon
        sx={{ cursor: "pointer", fontSize: 18 }}
        onClick={() => onChangeReverse(Math.max(min, valueReverse - 1))}
        color={"action"}
      />
      <GreySlider
        value={valueReverse}
        onChange={(_, v) => onChangeReverse(v as number)}
        min={min}
        max={max}
        step={1}
        size={"small"}
      />
      <AddSharpIcon
        sx={{ cursor: "pointer", fontSize: 18 }}
        onClick={() => onChangeReverse(Math.min(max, valueReverse + 1))}
        color={"action"}
      />
    </Stack>
  );
};

const useReverseScale = (
  value: number,
  onChange: Dispatch<number>,
  min: number,
  max: number,
): [number, Dispatch<number>] => {
  const onChangeReverse = (v: number) => onChange(max + min - v);
  const valueReverse = max + min - value;
  return [valueReverse, onChangeReverse];
};
